import axios from "axios";
import { Config } from '../Utils/Config';
const BASE_URL = Config.API_URL; // process.env.REACT_APP_API_URL;

var configHeader = {};

export const axiosFetch = async (configObj) => {
 
  var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;
  var demo_token = localStorage.getItem('demo-token') !== null ? localStorage.getItem('demo-token') : null;

  var token =  userDetails !== null && JSON.parse(userDetails).token !== null ? JSON.parse(userDetails).token : "";
  if (token) {
    if (demo_token !== null) {
      configHeader = {
        'Content-Type': 'application/json',
        "Authorization" : `Bearer ${token}`,
        'Accept': "application/json, text/plain",
        'x-access-token' : demo_token
        // 'Authorization': 'Bearer ' + token
      }
     
    }
    else {
      configHeader = {
        'Content-Type': 'application/json',
        "Authorization" : `Bearer ${token}`,
        'Accept': "application/json, text/plain",
        // 'Authorization': 'Bearer ' + token
      }
    }
   
  }
  else {
    configHeader = {
      'Accept': "application/json, text/plain",
       'Content-Type': 'application/json'
    }
  }
   const ConfigAxios =  axios.create({
    baseURL: BASE_URL,
    headers: configHeader,
   });
  
  const { method, url, requestConfig = {} } = configObj;
  try {
    const res = await ConfigAxios[method.toLowerCase()](url, {
      ...requestConfig,
    });
    return res;
  } catch (err) {
    return err.response;
  }
};

export const setAuthToken = () => {  
  const userDetails = localStorage.getItem("user") !== null ? localStorage.getItem("user")  : null;
  const token = userDetails !== null && JSON.parse(userDetails).token !== null ? JSON.parse(userDetails).token : "";
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};


export const postRequest = async (url, payload=null) => {

  setAuthToken();
  try {
    const response = await axios({
      url: url,
      method: 'post',
      responseType: 'blob',
      data: payload,
    });
    return response;
  } catch (error) {
    console.error("Error making POST request:", error);
    throw error;
  }

};

export const postFormRequest = async (configObj) => {
  const { url, requestConfig = {} } = configObj;

  var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;
  var token =  userDetails !== null && JSON.parse(userDetails).token !== null ? JSON.parse(userDetails).token : "";

  try {
    const response = await axios.post(BASE_URL+url, requestConfig, {  headers: { 'Content-Type': 'multipart/form-data' ,  "Authorization" : `Bearer ${token}`,}  });
    return response;
  } catch (error) {
    console.error("Error making POST request:", error);
    throw error;
  }
}